/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Tpl_Filter_AllInputs */

const en_fw_tpl_filter_all = /** @type {(inputs: Fw_Tpl_Filter_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All`)
};

const id_fw_tpl_filter_all = /** @type {(inputs: Fw_Tpl_Filter_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semua`)
};

/**
* | output |
* | --- |
* | "All" |
*
* @param {Fw_Tpl_Filter_AllInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_tpl_filter_all = /** @type {((inputs?: Fw_Tpl_Filter_AllInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Tpl_Filter_AllInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_tpl_filter_all(inputs)
	return en_fw_tpl_filter_all(inputs)
});